
export default (theme) => ({
    paper: {
        backgroundColor: "#e9edef"
    },
    tabContainer: {
        borderBottom: `1px solid ${theme.palette.primary?.grey || '#e0e0e0'}`,
        minHeight: 48,
        backgroundColor: 'transparent',
    },
    tabButton: {
        minWidth: 0,
        textTransform: 'none',
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        marginRight: theme.spacing(0.5),
        backgroundColor: 'transparent',
        borderRadius: '12px',
        fontFamily: 'Inter, sans-serif',
        fontSize: 16,
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: 'normal',
        letterSpacing: '0.32px',
        textAlign: 'center',
    },
    tabButtonInactive: {
        backgroundColor: theme.palette.primary?.grey ? `${theme.palette.primary.grey}20` : '#f5f5f5',
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
        color: theme.palette.text?.secondary || '#757575',
        '& $tabIconInactive': {
            color: theme.palette.text?.secondary || '#757575',
        },
        borderRadius: '12px',
    },
    tabLabelWithIcon: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: theme.spacing(1),
    },
    tabIconLabel: {
        flexDirection: 'row',
    },
    tabIconActive: {
        color: 'var(--primary-blue-primary-main, #0F48B8)',
    },
    tabIconInactive: {
        color: theme.palette.text?.secondary || '#757575',
    },
    selectedTabButton: {
        minWidth: 0,
        color: 'var(--primary-blue-primary-main, #0F48B8)',
        backgroundColor: theme.palette.background?.paper || '#fff',
        fontFamily: 'Inter, sans-serif',
        fontSize: 16,
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: 'normal',
        letterSpacing: '0.32px',
        textAlign: 'center',
    },
    tabIndicator: {
        height: 4,
        backgroundColor: 'var(--primary-blue-primary-main, #0F48B8)',
        borderRadius: '2px 2px 0 0',
    },
    // Legacy tab styles (when createStaffV2 flag is off)
    tabContainerLegacy: {
        borderBottom: '2px solid #adaeaf',
        minHeight: 48,
    },
    tabButtonLegacy: {
        ...theme.typography.t18,
        minWidth: 0,
    },
    selectedTabButtonLegacy: {
        ...theme.typography.bold,
        minWidth: 0,
    },
    tabIndicatorLegacy: {
        height: 5,
    },
    userProfileWrapper: {
        padding: '25px 20px'
    },
    userProfileHeading: {
        ...theme.typography.t35,
        ...theme.typography.bold,
        letterSpacing: '-0.08px',
        color: theme.palette.primary.jetBlack,
        lineHeight: '46px'
    },
    blueIconContainer: {
        backgroundColor: theme.palette.primary.cobalt,
        borderRadius: '100%',
        padding: 15,
        width: 45,
        height: 45,
        "& svg": {
            fontSize: 45,
            color: theme.palette.primary.white
        }
    },
    inactiveAccordion: {
        flexDirection: 'column'
    },
    userId: {
        ...theme.typography.t16,
        ...theme.typography.medium,
        letterSpacing: '1.5px',
        color: theme.palette.primary.main,
        lineHeight: '21px'
    },
    userProfileInfoWrapper: {
        marginLeft: 20
    },
    metaMainText: {
        ...theme.typography.t25,
        letterSpacing: '1.15px',
        lineHeight: '33px',
        color: theme.palette.primary.jetBlack,
    },
    metaSubText: {
        ...theme.typography.t16,
        letterSpacing: '1.5px',
        lineHeight: '21px',
        ...theme.typography.medium,
        color: theme.palette.primary.main,
    },
    blueBtn: {
        marginTop: 10,
        minWidth: 150,
        backgroundColor: theme.palette.primary.main,
        color: 'white',
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
        }
    },
    contentAreaContainer: {
        borderBottom: `1px solid ${theme.palette.primary.grey}`
    },
    contentSectionPadding: {
        padding: '10px 30px'
    },
    contentAreaChip: {
        borderRadius: 4,
        padding: '0px 5px',
        ...theme.typography.t16,
        ...theme.typography.medium,
        letterSpacing: '1.43px',
        lineHeight: '15.7px'
    },
    blueBox: {
        backgroundColor: theme.palette.primary.main
    },
    blueBoxTitle: {
        ...theme.typography.t14,
        letterSpacing: '0.07px',
        color: theme.palette.primary.white,
        display: 'flex',
        alignItems: 'center'
    },
    blueBoxValue: {
        ...theme.typography.bold,
        ...theme.typography.t30,
        letterSpacing: '0.07px',
        color: theme.palette.primary.white,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end'
    },
    allActive: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.white,
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
        }
    },
    infographicBtn: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-end'
    },
    daysSelectionList: {
        display: "flex"
    },
    daysSelectionItem: {
        width: "initial",
        border: "1px solid rgba(0, 0, 0, 0.12)",
        height: 40,
        fontSize: 18,
        color: theme.palette.primary.cobalt,
        fontWeight: "bold",
        "&:first-child": {
            borderTopLeftRadius: 20,
            borderBottomLeftRadius: 20
        },
        "&:last-child": {
            borderTopRightRadius: 20,
            borderBottomRightRadius: 20
        }
    },
    activeDay: {
        backgroundColor: theme.palette.primary.cobalt,
        color: "white",
        "&:hover": {
            backgroundColor: theme.palette.primary.cobalt
        }
    },
    profileMargin: {
        margin: '95px 15px 0px'
    },
    facilitiesSectionHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: theme.spacing(2),
        flexWrap: 'wrap',
        gap: theme.spacing(2),
    },
    facilitiesHeading: {
        ...theme.typography.t25,
        ...theme.typography.bold,
        marginBottom: theme.spacing(1),
        color: theme.palette.primary?.jetBlack || theme.palette.text.primary,
    },
    facilitiesExplainer: {
        ...theme.typography.t16,
        marginBottom: 0,
        color: theme.palette.text.secondary,
    },
    addFacilityBtn: {
        flexShrink: 0,
        textTransform: 'none',
        minWidth: 140,
    },
});